export default __webpack_public_path__ + "static/media/Vambraces of the Atlantean.283c966d.jpg";